import React from 'react';
import { DropdownItem } from 'reactstrap';

const MenuItem = (props) => <DropdownItem {...props}>
  {props.children}
</DropdownItem>;

export default MenuItem;